import Oidc from 'oidc-client';

new Oidc.UserManager().signinSilentCallback();
